<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title class="blue darken-3">
        <span class="title white--text">Purchase Order Item Details</span>
      </v-card-title>
      <v-card-text>
        <v-flex>
          <v-card>
            <v-card-text class="font-weight-bold">
              <v-layout row wrap>
                <v-flex xs12 sm6 md4>
                  <span>Product Code :</span>
                  <v-chip>
                    <span>{{ poItem.productCode }}</span>
                  </v-chip>
                </v-flex>
                <v-flex sm12 md8>
                  <span>Product Name :</span>
                  <v-chip>
                    <span>{{ poItem.productName }}</span>
                  </v-chip>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <span>Factor/Unit :</span>
                  <v-chip>
                    <span>{{ poItem.factorUnitName }}</span>
                  </v-chip>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <span>PO Qty :</span>
                  <v-chip>
                    <span>{{ poItem.qty | decFormat(6) }}</span>
                  </v-chip>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <span>Unit Cost :</span>
                  <v-chip>
                    <span>{{ poItem.unitCost | numFormat }}</span>
                  </v-chip>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <span>Currency :</span>
                  <v-chip>
                    <span>{{ poItem.currencyCode }}</span>
                  </v-chip>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <span>Exchange Rate :</span>
                  <v-chip>
                    <span>{{ poItem.currencyExchangeMMK | numFormat }}</span>
                  </v-chip>
                </v-flex>
                <v-flex xs12 sm6 md4>
                  <span>Unit Cost MMK :</span>
                  <v-chip>
                    <span>{{ poItem.unitCostMMK | numFormat }}</span>
                  </v-chip>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex class="mt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="poItemDetailList"
              class="elevation-1"
              :loading="showListLoading"
              :total-items="totalRows"
              :rows-per-page-items="rowsPerPageItems"
              :pagination.sync="pagination"
              :must-sort="true"
            >
              <template slot="items" slot-scope="props">
                <td>
                  {{ props.item.stockInDateInMilliSeconds | formatMsDate }}
                </td>
                <td>{{ props.item.stockInNo }}</td>
                <td>{{ props.item.stockInFactorUnitName }}</td>
                <td>{{ props.item.stockInQty | decFormat(6) }}</td>
                <td>
                  {{ props.item.qcDateInMilliSeconds | formatMsDate }}
                </td>
                <td>{{ props.item.qcIssueNo }}</td>
                <td>{{ props.item.qcNo }}</td>
                <td>
                  {{ props.item.qcFactorUnitName }}
                </td>
                <td>{{ props.item.qcQty | decFormat(6) }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { purchaseOrderService } from "../../services/purchase-order-service";

export default {
  name: "PurchaseOrderItemDetailDialog",
  props: {
    showDialog: Boolean,
    poItem: Object,
  },
  data: () => ({
    showListLoading: false,
    queryParams: {
      poItemId: "",
    },
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "",
      totalItems: 0,
    },
    totalRows: 0,
    rowsPerPageItems: [25, 50, 100],
    headers: [
      { text: "Stock In Date", sortable: false },
      { text: "Stock In No", sortable: false },
      { text: "Stock In Factor/Unit", sortable: false },
      { text: "Stock In Qty", sortable: false },
      { text: "QC Issue Date", sortable: false },
      { text: "Issue No", sortable: false },
      { text: "QC No", sortable: false },
      { text: "QC Pass Unit", sortable: false },
      { text: "QC Pass Qty", sortable: false },
    ],
    poItemDetailList: [],
  }),

  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.$emit("close");
      },
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getPoItemDetailList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams.poItemId = this.poItem.id;

          this.getPoItemDetailList();
        }
      },
    },
  },

  methods: {
    getPoItemDetailList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      purchaseOrderService
        .getPoItemDetailList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.poItemDetailList = res.data.poItemDetailList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
  },
};
</script>